// extracted by mini-css-extract-plugin
export default {"searchResultDiv":"SearchResult_searchResultDiv__jL6sp"};